import * as React from 'react';
import cx from 'classnames';

import { Enum } from '../../common/types';

export const CKBadgeVariant = Enum('default', 'rounded');
export type CKBadgeVariant = Enum<typeof CKBadgeVariant>;

export interface CKBadgeProps {
  className?: string;
  variant?: CKBadgeVariant;
}

export const CKBadge: React.FC<CKBadgeProps> = ({
  children,
  className,
  variant = 'default',
}) => {
  const badgeClass = cx(
    'ck-badge',
    {
      'ck-badge--rounded': variant === 'rounded',
    },
    className
  );
  return <div className={badgeClass}>{children}</div>;
};
